// Master, hand-maintained list of every Galerie community location — built
// and in development, across all brands — for the Portfolio page's grid and
// map. Same card shape as galerieProjects.js/corsoProjects.js. imgId/link/
// blurb values are reused from those files and managementAssets.js on
// purpose, so a photo already uploaded to Storage for one of those pages
// shows up here automatically instead of needing a second upload.
//
// address: full street address, used to geocode a pin for PortfolioMap.js.
// Leave null (with a TODO) if no verified address exists yet — the map
// simply won't place a pin for that entry until one is added.
//
// state: full state name (matches the "name" property on the us-atlas
// states TopoJSON used by PortfolioMap.js) — used to filter this list when
// a state is clicked on the map.

import corso_hero from "../Images/portfolio/cards/portfolio_cards_corso_atlanta.webp";
import collection_hero from "../Images/portfolio/cards/portfolio_cards_druid_hills.webp";
import development_hero from "../Images/portfolio/cards/portfolio_cards_chevy_chase.webp";
import vp_hero_a from "../Images/portfolio/cards/portfolio_cards_vp_milton.webp";
import vp_hero_b from "../Images/portfolio/cards/portfolio_cards_vp_alpharetta.webp";
import carousel_23 from "../Images/portfolio/cards/portfolio_cards_vp_peachtree_corners.webp";

export const portfolio_projects = [
  {
    id: "corso-atlanta",
    name: "Corso Atlanta",
    brand: "Corso",
    location: "Atlanta, GA",
    state: "Georgia",
    address: "3200 Howell Mill Rd NW, Atlanta, GA 30327",
    status: "expansion-underway",
    blurb: "City Homes · Independent Living · Assisted Living · Memory Care",
    link: "https://www.corsoresidences.com/atlanta/",
    imgId: "asset-corso-atlanta",
    placeholderImg: corso_hero,
  },
  {
    id: "corso-druid-hills",
    name: "Corso Druid Hills",
    brand: "Corso",
    location: "Atlanta, GA",
    state: "Georgia",
    address: "1260 Briarcliff Rd NE, Atlanta, GA 30306",
    status: "in-development",
    blurb:
      "A New Chapter For An Historic Estate. Corso Druid Hills reimagines the storied Briarcliff campus as a hub of wellness and hospitality.",
    link: "https://www.corsoresidences.com/druid-hills/",
    imgId: "galerie-project-druid-hills",
    placeholderImg: collection_hero,
  },
  {
    id: "corso-chevy-chase",
    name: "Corso Chevy Chase",
    brand: "Corso",
    location: "Chevy Chase, MD",
    state: "Maryland",
    address: "7100 Connecticut Ave, Chevy Chase, MD 20815",
    status: "under-construction",
    blurb:
      "A New Standard In A Storied Town. 400+ luxury residences seated in the heart of Chevy Chase, Maryland.",
    link: "https://www.corsoresidences.com/chevy-chase/",
    imgId: "galerie-project-chevy-chase",
    placeholderImg: development_hero,
  },
  {
    id: "corso-tysons",
    name: "Corso Tysons",
    brand: "Corso",
    location: "Tysons, VA",
    state: "Virginia",
    address: "7600 Colshire Drive West, Mclean, VA 22102",
    status: "in-development",
    blurb:
      "The Parisian Towers. Seated in the heart of Tysons, Virginia, Corso Tysons welcomes you to the city's most coveted address.",
    link: "https://www.corsoresidences.com/tysons",
    imgId: "Tysons_Recolor_2",
    placeholderImg: corso_hero,
  },
  {
    id: "vp-milton",
    name: "Village Park Milton",
    brand: "Village Park",
    location: "Alpharetta, GA",
    state: "Georgia",
    address: "555 Wills Rd, Alpharetta, GA 30009",
    status: "open",
    blurb:
      "Cottages & Bungalows · City Homes · Independent Living · Assisted Living · Memory Care",
    link: "https://villageparkseniorliving.com/communities/village-park-milton/",
    imgId: "vpm_man_compressed",
    placeholderImg: vp_hero_a,
  },
  {
    id: "vp-alpharetta",
    name: "Village Park Alpharetta",
    brand: "Village Park",
    location: "Alpharetta, GA",
    state: "Georgia",
    address: "12300 Morris Rd, Alpharetta, GA 30005",
    status: "open",
    blurb:
      "Cottages & Bungalows · City Homes · Independent Living · Assisted Living · Memory Care",
    link: "https://villageparkseniorliving.com/communities/village-park-alpharetta/",
    imgId: "vpa_man_compressed",
    placeholderImg: vp_hero_b,
  },
  {
    id: "vp-peachtree-corners",
    name: "Village Park Peachtree Corners",
    brand: "Village Park",
    location: "Peachtree Corners, GA",
    state: "Georgia",
    address: "5701 Spalding Dr, Peachtree Corners, GA 30092",
    status: "open",
    blurb: "Cottages & Bungalows · Independent Living · Assisted Living · Memory Care",
    link: "https://villageparkseniorliving.com/communities/village-park-peachtree-corners/",
    imgId: "vppc_man_compressed",
    placeholderImg: carousel_23,
  },
  {
    id: "vp-west-cobb",
    name: "Village Park West Cobb",
    brand: "Village Park",
    location: "Marietta, GA",
    state: "Georgia",
    address: "3292 Ernest W Barrett Pkwy NW, Marietta, GA 30064",
    status: "managed",
    blurb: "Independent Living · Assisted Living · Memory Care",
    link: "https://villageparkseniorliving.com/communities/village-park-west-cobb/",
    imgId: "vpwc_man_compressed",
    placeholderImg: corso_hero,
  },
  {
    id: "vp-fayetteville",
    name: "Village Park Fayetteville",
    brand: "Village Park",
    location: "Fayetteville, GA",
    state: "Georgia",
    address: "936 W Lanier Ave, Fayetteville, GA 30215",
    status: "managed",
    blurb: "Independent Living · Assisted Living · Memory Care",
    link: "https://villageparkseniorliving.com/communities/village-park-fayetteville/",
    imgId: "vpf_man_compressed",
    placeholderImg: collection_hero,
  },
  {
    id: "lotus-park-douglasville",
    name: "Lotus Park Douglasville",
    brand: "Lotus Park",
    location: "Douglasville, GA",
    state: "Georgia",
    address: null, // TODO: no verified street address yet — won't get a map pin until one is added
    status: "managed",
    blurb: "Independent Living · Assisted Living · Memory Care",
    link: "#", // TODO: real Lotus Park Douglasville URL
    imgId: "lpd_man_compressed",
    placeholderImg: development_hero,
  },
];

// States flagged as upcoming on PortfolioMap.js (hoverable, blue "Future
// Development" popup) and on the Home page's HomeStatesHighlight — no
// portfolio_projects entry backs them yet, so they can't be derived from
// the list above the way STATES_WITH_LOCATIONS is in those two files.
export const FUTURE_DEVELOPMENT_STATES = ["Texas", "New York"];
